import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const JoiasAcessorios = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Joias";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.joiasAcessorios})` }}>
        <div className="servico-hero-overlay">
          <h1>Joias</h1>
          {/* <p>Para quem procura por joias e acessórios</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Joias e Acessórios */}
        <section className="acessorios-grid">
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.elosJoias} alt="" /></div>
            <h3>Peças</h3>
            <p>Elos, feches e tarrachas.</p>
          </div>

          {/*
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.fechesJoias} alt="" /></div>
            <h3>Feches</h3>
            <p>Travas e sistemas de fechamento.</p>
          </div> */}

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.limpezaJoias} alt="" /></div>
            <h3>Limpeza</h3>
            <p>Limpa joias.</p>
          </div>

          <div></div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('joias')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('joias')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default JoiasAcessorios;